const isMartinGrup = (data) => {
  const grupmartin = [5, 13]
  if (grupmartin.includes(data)) {
    return true
  }
  return false
}

export default isMartinGrup
